
import React, { useState, ReactNode, cloneElement } from "react";
import {Box,
        Avatar} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Config from "../../config";
import {UserProfileModel} from '../../models/modelsUserConfiguration';


/*DEFINITION FOR IMAGE ICONS */

type UserAvatarProps = {
  userProfile?: UserProfileModel | null,
  size?: number;
}

export const UserAvatar = (
  {
    userProfile,
    size=40
  }: UserAvatarProps) => {

    let imageServiceUrl = undefined;
    if(userProfile?.Avatar_c){
      imageServiceUrl = `${Config.getInstance().getCoordinationServiceURL()}${userProfile.Avatar_c.url}`;
    }

    return (
        <Avatar
           src={imageServiceUrl}
           alt={userProfile?.Avatar_c?.alt}
           sx={{
             width: size,
             height: size
           }}
        >
          {userProfile ?
            <Box sx={{transform: "translateY(0.075em)"}}>
              {userProfile.initials}
            </Box>
            :
            <AccountCircle />
          }
        </Avatar>
    )
  }
